module.exports = __webpack_public_path__ + "img/1w.7c49c331.svg";